import { render, staticRenderFns } from "./CRUDTable.vue?vue&type=template&id=168db161&scoped=true"
import script from "./CRUDTable.vue?vue&type=script&lang=js"
export * from "./CRUDTable.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable.vue?vue&type=style&index=0&id=168db161&prod&lang=css"
import style1 from "./CRUDTable.vue?vue&type=style&index=1&id=168db161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168db161",
  null
  
)

export default component.exports